/** @type {string} */
const carouselComponent = "Carousel";
export default carouselComponent;
